import React from "react";
//#region types
import { PrintMonthlyBalanceReportProps } from "models/propTypes/accountingPropTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModelFinancialReport } from "wint-api-client/dist/types";
//#endregion
//#region components
import { NestedTablePrint } from "components/common";
import useFinancialReportRow from "../../hooks/useFinancialReportRow";
//#endregion
import { FinancialReportHelper, LocalizationHelperInstance } from "utils/helpers";

const PrintMonthlyBalanceReport: React.FC<PrintMonthlyBalanceReportProps> = (props) => {
  const { title, subtitle, result, ubHeaderDescription, showAccountNumber } = props;

  const { descriptionFormatter } = useFinancialReportRow(showAccountNumber);

  return (
    <NestedTablePrint<
      WintSuperkollAPIModelFinancialReport.FinancialReportRow,
      WintSuperkollAPIModelFinancialReport.FinancialReportRowColumn
    >
      title={title}
      subTitle={subtitle}
      rows={result}
      properties={{
        description: {
          description: TranslationKeys.Common.Name,
          formatter: descriptionFormatter,
        },
      }}
      repeatProperties={{
        key: "columns",
        properties: {
          uB: {
            description: ubHeaderDescription,
            formatter: (row: WintSuperkollAPIModelFinancialReport.FinancialReportRowColumn) =>
              LocalizationHelperInstance.getFormattedCurrency(row.uB ?? 0, undefined, 0, 0),
            alignment: "right",
          },
        },
      }}
      childrenKey="children"
      rowDisplayType={FinancialReportHelper.getBalanceReportRowDisplayType}
      maxRepeatColumns={12}
      repeatColumnDefaultWidth={50}
    />
  );
};

export default PrintMonthlyBalanceReport;
